import React from 'react';
import classNames from 'classnames';
import { useTranslator } from '../../../hooks/useTranslator';
export const useProgressBar = () => {
  const [progress, setProgress] = React.useState(0);
  React.useEffect(() => {
    const duration = 10;
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 70) {
          clearInterval(interval);
          return 70;
        }
        return prevProgress + 100 / duration;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  return { bind: { progress }, setProgress };
};
export const ProgressBar = ({ progress, colorClass = 'bg-LightBlue-500', colorClassBase = 'bg-DarkBlue-700',Message }) => {
  const { t } = useTranslator();
  return (
    <div className="w-full flex flex-col gap-4 text-white text-4">
      <div className={classNames('h-3 w-full rounded-full ', colorClassBase)}>
        <div className={classNames('h-full rounded-full', colorClass)} style={{ width: `${progress??0}%` }}></div>
      </div>
      <div className="text-center text-4 font-semibold text-gray-800 pb-1">
        {t("enad_feed_back_progress", { progress })} {Message?<Message/>:''}
      </div>
    </div>
  );
};